import { render, staticRenderFns } from "./VNewToken.vue?vue&type=template&id=5bac91d2&scoped=true"
import script from "./VNewToken.vue?vue&type=script&lang=js"
export * from "./VNewToken.vue?vue&type=script&lang=js"
import style0 from "./VNewToken.vue?vue&type=style&index=0&id=5bac91d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bac91d2",
  null
  
)

export default component.exports